<template>
  <div class="">
    <div class="flex items-center justify-center enter-error-container">
      <div class="enter-error-wrapper border-2 items-center justify-center">
        <div class="flex flex-col text-center">
          <p class="font-bold text-2xl">인증 정보가 만료되었습니다.</p>
          <p>확인 버튼을 누르면 기존 인증(로그인, OTP)정보가 삭제됩니다.</p>
          <p>인증(로그인, OTP)정보 후 다시 입장 해주세요.</p>
        </div>
        <button type="button" class="btn-logout" @click="onLogout">
          <span>확인</span>
        </button>
      </div>
    </div>


  </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: 'RoomEnterError',
  components: {},
  methods: {
    ...mapActions('auth', ['logout']),
    async onLogout() {
      await this.logout()
      this.$alert({
        text: this.$t('인증 정보가 삭제되었습니다.<br/>브라우저 종료 후 다시 접속해주세요.'),
        ok: async () => {
          window.close()
        },
        onlyOk: true
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.enter-error-container {
  height: 100vh;
}
.enter-error-wrapper {
  width: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
}
.btn-logout {
  width: 66%;
  height: 2.5rem;
  background-color: rgb(147 197 253);
}
</style>